import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'badge-renderer',
  templateUrl: './badge-renderer.component.html',
  standalone: true,
  imports: [TranslateModule]
})
export class BadgeRendererComponent implements ICellRendererAngularComp {
  foreignCurrency: any;
  preApprovalBalance: any;

  constructor(private translate: TranslateService) { }

  initilize(params: ICellRendererParams) {
    if (params && params.data) {
      if (params.data.spentCurrencyId > 0) {
        this.foreignCurrency = this.translate.instant(params.colDef.headerComponentParams.text);
      }
    }

    //delete it after testing
    this.foreignCurrency = "FX currency";
  }

  agInit(params: any): void {
    this.initilize(params);
  }

  refresh(params: any): boolean {
    this.initilize(params);
    return true;
  }

}